import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Button } from '../../../../Controls/Button/index.js';
import Icons from '../../../../Elements/Icons/index.js';
/**
 * The prev/next page buttons shared by `Table.Info` and `Table.Pagination`. Both bounds come from
 * `usePagination` (`hasPrev`/`hasNext`), which also covers `total === 0` while loading with no data.
 */
export const PaginationControls = memo(function PaginationControls({ hasPrev, hasNext, prevPage, nextPage, prevDataTestId = 'backward-button', nextDataTestId = 'forward-button', }) {
    return (_jsxs(_Fragment, { children: [_jsx(Button, { secondary: true, iconOnly: true, onClick: prevPage, disabled: !hasPrev, dataTestId: prevDataTestId, children: _jsx(Icons.Arrow, { align: 'left' }) }), _jsx(Button, { secondary: true, iconOnly: true, onClick: nextPage, disabled: !hasNext, dataTestId: nextDataTestId, children: _jsx(Icons.Arrow, { align: 'right' }) })] }));
});
